import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { ImagesEntity } from '@galabid/gb-dashboard/shared/data-access-images'

@Component({
  selector: 'gb-image-upload-button',
  templateUrl: './gb-image-upload-button.component.html',
  styleUrls: ['./gb-image-upload-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbImageUploadButtonComponent {
  @Input() images: ImagesEntity[] | undefined | null = []
  @Input({ required: true }) buttonText!: string
  @Input({ required: true }) labelText!: string
  @Input() showEmptyImageArea: boolean = false
  @Input() backdropColor: string = 'var(--gb-background-color-500)'
  @Input() disabled: boolean = false
  @Input() isMulti: boolean | null | undefined = true
  @Input() cover: boolean = false
  @Input() maxImages?: string
  @Input() maxWidth?: number
  @Input() maxHeight?: number

  @Input() secondaryButtonText?: string
  @Output() secondaryButtonClicked = new EventEmitter<void>()

  @Output() openUploadDialog = new EventEmitter<void>()

  previews = [...Array(3).keys()]

  handleChooseImageClick() {
    if (!this.disabled) this.openUploadDialog.emit()
  }

  handleSecondaryButtonClick() {
    this.secondaryButtonClicked.emit()
  }
}
